import axios from "../../../../axios";
import Cookies from "js-cookie";

export const LogoutEmp = async (userTokenExpiry) => {
  const token = Cookies.get("employeeToken");
 
  return axios.post("/api/Auth/Employee/Logout", {
    token,userTokenExpiry
  });
}; 

export const GetEmployeeName = async (Token) => {
	return axios.post("/api/Auth/Employee/Verify", { Token });
}; 